import { computed, Ref, WritableComputedRef } from 'vue';

import Validatable from '@/validator/Validatable';

export const getComputedEntityProperty = <T = Validatable, U = any>(
  entity: Ref<T>,
  property: keyof T & string,
  action: (args: { package: T; value: U }) => void,
  callbacks: object = {},
  options?: {
    mutation?: (value: any) => U;
    propertyOverride?: string;
    fallbackValue?: U;
  },
): WritableComputedRef<U> => {
  return computed({
    get() {
      const { fallbackValue } = options || {};
      return (entity.value[property] as U) ?? fallbackValue;
    },
    set(value: U) {
      const { mutation, propertyOverride } = options || {};
      action({ package: entity.value, value: mutation ? mutation(value) : value });
      callbacks?.[propertyOverride ?? property]?.(value);
    },
  });
};
